import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addonCatalogRefresh } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { queryKeys } from '../query-keys';

/**
 * useRefreshCatalog drops Portainer's cached add-on catalog, then refetches the
 * list. The refetch waits for the refresh: before it, the list would replay the
 * cached catalog. Administrators only.
 */
export function useRefreshCatalog() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await addonCatalogRefresh();
    },
    ...withInvalidate(queryClient, [queryKeys.list()]),
    ...withError('Unable to refresh the add-on catalog'),
  });
}
